module.exports = __webpack_public_path__ + "img/23fc2e9.png";